import React, { Component } from 'react'
import _ from 'lodash'
import { observer, inject } from 'mobx-react'
import { Row, Col, Modal, Card } from 'antd'
import { compose } from 'recompose'
import moment from 'moment'

const { Meta } = Card

class Index extends Component {
	constructor(props) {
		super(props)

		this.state = {
		}
	}

	render() {
		const { visible, onClose, dtr } = this.props
		return (
			<Modal
				title='View DTR Photo'
				width='60%'
				visible={visible}
				onCancel={onClose}
				destroyOnClose
				footer={null}
			>
				<Row gutter={24}>
					{
						dtr.photos.map((i, key) => {

							return (
								<Col key={i.uid} md={8} sm={12}>
									<Card
										style={{ cursor: 'pointer' }}
										cover={
											<img
												alt="example"
												src={
													(i.file_url) ? `${process.env.REACT_APP_BACKEND_API}${i.file_url}` :
														'https://gw.alipayobjects.com/zos/rmsportal/JiqGstEfoWAOHiTxclqi.png'
												}
											/>
										}
									>
										<Meta
											title={i.log_status}
											description={moment(i.created_at).format('LLL')}
										/>
									</Card>
								</Col>
							)
						})
					}
				</Row>
			</Modal>
		)
	}
}

const composed = compose(
	inject('AuthStore'),
	observer
)

export default composed(Index)